import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

function handleNotFoundError(err: HttpErrorResponse): Observable<any> {
    if (err.status === 404) {
        window.location.href = window.location.origin + '/not-found';
    }
    return throwError(() => err);
}

export function notFoundInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
    return next(req).pipe(catchError(x => handleNotFoundError(x))) as Observable<HttpEvent<unknown>>;
}